/**
 * wait utility function
 * @param {number} ms delay
 * @return {promise}
 */
export const wait = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

/**
 * Format numbers
 * @param {number} number // Number to format.
 * @return {string}
 */
export const formatNumber = number => {
  return number.toLocaleString('nl-NL');
};

/**
 * Format date
 * @param {string} date // Date to format.
 * @return {string}
 */
export const formatDate = date => {
  return new Date(date).toLocaleTimeString('nl-NL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
